import script from "./ViewWarrantsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWarrantsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewWarrantsPage.vue?vue&type=style&index=0&id=535cd1c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535cd1c4"]])

export default __exports__